module.exports = __webpack_public_path__ + "static/media/29BDOS4.ccb30ec6.jpg";